

export const GET_CENTRAL_SERVICE_ITEM_LIST = "GET_CENTRAL_SERVICE_ITEM_LIST"
export const GET_CENTRAL_SERVICE_ITEM_LIST_SUCCESS = "GET_CENTRAL_SERVICE_ITEM_LIST_SUCCESS"


export const DELETE_CENTRAL_SERVICE_ITEM_LIST_ID = "DELETE_CENTRAL_SERVICE_ITEM_LIST_ID"
export const DELETE_CENTRAL_SERVICE_ITEM_LIST_ID_SUCCESS = "DELETE_CENTRAL_SERVICE_ITEM_LIST_ID_SUCCESS"

export const EDIT_CENTRAL_SERVICE_ITEM_ID = "EDIT_CENTRAL_SERVICE_ITEM_ID"
export const EDIT_CENTRAL_SERVICE_ITEM_ID_SUCCESS = "EDIT_CENTRAL_SERVICE_ITEM_ID_SUCCESS"

export const UPDATE_CENTRAL_SERVICE_ITEM_ID = "UPDATE_CENTRAL_SERVICE_ITEM_ID"
export const UPDATE_CENTRAL_SERVICE_ITEM_ID_SUCCESS = "UPDATE_CENTRAL_SERVICE_ITEM_ID_SUCCESS"

export const SAVE_CENTRAL_SERVICE_ITEM = "SAVE_CENTRAL_SERVICE_ITEM"
export const SAVE_CENTRAL_SERVICE_ITEM_SUCCESS = "SAVE_CENTRAL_SERVICE_ITEM_SUCCESS"

export const CENTRAL_SERVICE_ITEM_API_ERROR_ACTION = "CENTRAL_SERVICE_ITEM_API_ERROR_ACTION"


